export default __webpack_public_path__ + "static/media/work-map.ebfdde30.png";